<template>
 <div>
     <van-nav-bar
  title="修改密码"
  left-arrow
  @click-left="$router.go(-1)"
/>
      <van-cell-group>
  <van-field
    value="请输入旧密码"
     type="password"
    label="旧密码"
    v-model="old_password"
  />
  <van-field
    value="请输入新密码"
    label="新密码"
    type="password"
    v-model="password"
  />
   <van-field
    value="请输入确认密码"
    label="确认密码"
    type="password"
    v-model="confirm_password"
  />
</van-cell-group>
<van-button type="danger" size="large" @click="doEditPwd">提交</van-button>
 </div> 
</template>


<script>
export default {
   data() {
    return {
        old_password:'',
        password:'',
        confirm_password:'',
    };
  },
  methods:{
      doEditPwd(){
        this.Post({
            old_password:this.old_password,
            password:this.password,
            confirm_password:this.confirm_password,
        }, "/main/changepassword", res => {
            if (res.states == 1) {
                 this.Toast.success('密码修改成功');
               this.$router.replace('/login')
            }else{
                this.Toast.fail(res.msg);
            }
        });
      },
  } 
}
</script>

<style lang="less" rel="stylesheet/less" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/account/editPwd.vue